import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useSwingProfileSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const exactConfig = useStore((state) => state.quote.exactConfig);

  const stilesRailsProfile = useStore(
    (state) => state.quote.stilesRailsProfile
  );

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    let update = { stilesRailsProfile: !checked ? label : "" };

    if (!checked && label === "Square") {
      update["stickingStops"] = "Square";
    }

    addToQuote(update, "stilesRailsProfile");

    const reqKey = "Stiles and Rails Profile";

    if (!checked && findRequired(reqKey)) removeRequired(reqKey);
  };

  const variant = (label: string) =>
    label === stilesRailsProfile ? "filled" : "outlined";

  const checkMark = (label: string) => label === stilesRailsProfile;

  return {
    checkMark,
    variant,
    handleClick,
    stilesRailsProfile,
    exactConfig,
  };
}

export default useSwingProfileSelector;
